import {useState} from "react";
import {requestPwaInstall, usePwaInstallPrompt} from "@/hooks/usePwaInstallPrompt";
import {showErrorToast} from "@/utils/toast";
import {Button} from "@chayka/ui";

const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";

export const PwaInstallPrompt = () => {
  const [isPrompting, setIsPrompting] = useState(false);
  const {deferredPrompt, isInstalled, manualInstallMode} = usePwaInstallPrompt();

  const handleInstallClick = async () => {
    setIsPrompting(true);

    try {
      await requestPwaInstall();
    } catch {
      showErrorToast("Не удалось открыть окно установки. Попробуйте ещё раз.");
    } finally {
      setIsPrompting(false);
    }
  };

  if (isInstalled || (!deferredPrompt && !manualInstallMode) || isLocalhost) {
    return null;
  }

  const description =
    manualInstallMode === "ios-safari"
      ? "В Safari нажмите «Поделиться» и выберите «На экран Домой», чтобы установить приложение Чайки."
      : manualInstallMode === "ios-browser"
        ? "На iPhone и iPad установка работает через Safari. Откройте сайт в Safari, нажмите «Поделиться» и выберите «На экран Домой»."
        : "Добавьте Чайку на главный экран, чтобы открывать сервис как отдельное приложение.";

  return (
    <div className="mt-4 mb-4 flex w-full flex-col gap-3 rounded-2xl border border-stroke bg-background p-4">
      <div className="flex flex-col gap-1">
        <div className="text-sm font-semibold">Установить приложение</div>
        <div className="text-sm text-secondary-text">{description}</div>
      </div>
      {deferredPrompt ? (
        <Button
          className="self-stretch"
          size="medium"
          variant="secondary"
          loading={isPrompting}
          onClick={handleInstallClick}
        >
          Установить приложение
        </Button>
      ) : null}
    </div>
  );
};
